// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1CpMJ","calendarButtons":"ClockData_calendarButtons__3P2Dy"};